import React, { Fragment, useEffect, useState } from 'react'
import {Container,Row,Col,Button,Form} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from "../../context/auth/useAuth"
import { Link, useNavigate } from 'react-router-dom'

const clientCredentials = {}

export default function Login() {
    const { t } = useTranslation()
    const [islogging, setIslogging] = useState(false)
    const {loginClient, clientauth} = useAuth()
    const navigate = useNavigate()

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIslogging(true)
        loginClient(clientCredentials).then(() => {
            setIslogging(false)
        })
    }

    useEffect(() => {
        if (clientauth) {
            if(clientauth?.roles?.some(role => role.profileType === 'Superadmin')){
                navigate(`/${t("url.admin.admin")}/${t("url.admin.dashboard")}`)
            }else{
                navigate(`/${t("url.client.client")}/${t("url.client.dashboard")}`)
            }
        }
    }, [clientauth, navigate, t])

    return (
        <Fragment>
            <header className="cabecera d-flex align-items-center px-4">
                <Link to='/'><img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" height={28} /></Link>
            </header>
            <Container fluid className='p-0 m-0'>
                <Row className='p-0 m-0 centro-auth'>
                    <Col md={7} className='d-none d-md-flex align-items-center justify-content-center aside-auth' style={{
                        background: 'linear-gradient(135deg, #0B0C0E 0%, #1A1B1E 100%)',
                    }}>
                        <div style={{maxWidth: 420, color: 'white', padding: 40}}>
                            <h1 style={{color: 'white', fontSize: 40, marginBottom: 16}}>SDPlay</h1>
                            <p style={{fontSize: 16, opacity: 0.7, lineHeight: 1.6}}>
                                Plataforma de gestión para clubes deportivos. Administra actividades, reservas, ticketing y pagos en un solo lugar.
                            </p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} className='d-flex align-items-center p-5'>
                        <Container className='login-form-container'>
                            <div className='login-brand'>
                                <img src="/images/logotipo-sdplay-cabecera.svg" alt="SDPlay" />
                            </div>
                            <h1 className='login-title'>{t('signin.signin')}</h1>
                            <p className='login-subtitle'>{t('signin.subtitle') || 'Accede a tu panel de gestión'}</p>
                            <Form className="formulario" onSubmit={ handleSubmit}>
                                <Row className="mb-4">
                                    <Col>
                                        <Form.Label htmlFor='login_username'>{t('signin.username')}</Form.Label>
                                        <Form.Control name="login_username" type="text" autoComplete="off" onChange={ (e) => clientCredentials.username = e.target.value} tabIndex="1"/>
                                    </Col>
                                </Row>
                                <Row className="mb-4">
                                    <Col>
                                        <div className='d-flex justify-content-between align-items-center mb-2'>
                                            <Form.Label htmlFor='login_password' className='mb-0'>{t('signin.password')}</Form.Label>
                                            <Link to={`/${t("url.auth.forgotpassword")}`} className='link' style={{fontSize:13}} tabIndex="3">{t('signin.passwordforgoten')}</Link>
                                        </div>
                                        <Form.Control name="login_password" type="password" autoComplete="off" onChange={ (e) => clientCredentials.password = e.target.value} tabIndex="2"/>
                                    </Col>
                                </Row>
                                <Row className="mt-5">
                                    <Col>
                                        <Button variant='primary' type="submit" className="w-100" tabIndex="4">
                                        {islogging
                                            ? <span className="spinner-border spinner-border-sm align-middle"></span>
                                            : <>{t('signin.login')}</>
                                        }
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='text-center pt-4'>
                                        <span style={{fontSize:13, color:'var(--text-secondary)'}}>{t('signin.createaccount')}</span><br/>
                                        <Link to={`/${t("url.auth.registerclient")}`} className='btn btn-default w-100 mt-2' tabIndex="5">
                                            {t('signin.register')}
                                        </Link>
                                    </Col>
                                </Row>
                            </Form>
                        </Container>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}